// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"aa896709bbd98ce4baac","453":"ac2575b5f94609020acd"}[chunkId] + ".js";
};